import { Component, computed, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { QuizFacade } from '@app/store/quiz';
import { EntityListComponent, UnavailableComponent } from '@shared/components';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-quiz-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, ButtonModule, EntityListComponent, DeleteButtonComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly quizFacade = inject(QuizFacade);

    private readonly id = this.route.parent?.snapshot.params['id'];
    readonly quiz = this.quizFacade.quiz(this.id);
    readonly loading = this.quizFacade.loading(this.id);
    readonly error = this.quizFacade.error(this.id);
    readonly saving = this.quizFacade.saving;

    readonly questionIds = computed(() => this.quiz()?.questionIds ?? []);

    constructor() {
        if (this.id) {
            this.quizFacade.getQuiz(this.id);
        }

        effect(() => {
            if (this.quizFacade.saved()) {
                this.close({ replaceUrl: !this.quiz() });
            }
        });
    }

    ngOnDestroy(): void {
        this.quizFacade.clear();
    }

    onEdit(): void {
        const quiz = this.quiz();
        if (quiz) {
            this.router.navigate([{ outlets: { modal: ['quizzes', 'edit', quiz.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
